import React from 'react'
import MUIDataTable from 'mui-datatables'
import Loader from 'react-loader-spinner'
import { HeaderTableCell } from '../containers.jsx'
import { formatDate } from '../../utils'
import Link from '@material-ui/core/Link'
import AITokenActionButton from './AITokenActionButton.jsx'

export const organizationKeyColumn = {
  name: 'organizationKey',
  label: 'Organization Key',
  options: {
    customHeadRender: () => <HeaderTableCell>Organization Key</HeaderTableCell>,
    filter: false,
    sortThirdClickReset: true,
  },
}

export default function AIEntitlementTable({
  title,
  entitlements,
  isEntitlementLoading,
  shallDisplayActionButton,
  dispatchResponse,
}) {
  const entitlementIdColumn = (entitlements) => ({
    name: 'entitlementId',
    label: 'Entitlement Id',
    options: {
      customHeadRender: () => <HeaderTableCell>Entitlement Id</HeaderTableCell>,
      customBodyRenderLite: (dataIndex) => {
        const id = entitlements[dataIndex].entitlementId

        return (
          <Link
            style={{ cursor: 'pointer' }}
            onClick={() => {
              return dispatchResponse(true, entitlements[dataIndex])
            }}
          >
            {id}
          </Link>
        )
      },
      filter: false,
      sortThirdClickReset: true,
    },
  })

  const productNameColumn = {
    name: 'productName',
    label: 'Product Name',
    options: {
      customHeadRender: () => <HeaderTableCell>Product Name</HeaderTableCell>,
      sortThirdClickReset: true,
    },
  }

  const assignedCreatedUser = {
    name: 'createdUser',
    label: 'Created User',
    options: {
      customHeadRender: () => <HeaderTableCell>Created User</HeaderTableCell>,
      filter: false,
      sortThirdClickReset: true,
    },
  }

  const startDateColumn = {
    name: 'startDate',
    label: 'Start Date',
    options: {
      customHeadRender: () => <HeaderTableCell>Start Date</HeaderTableCell>,
      filter: false,
      sortThirdClickReset: true,
      customBodyRenderLite: (dataIndex) => {
        if (entitlements[dataIndex].startDate) {
          return formatDate(entitlements[dataIndex].startDate)
        }
      },
    },
  }

  const expiryDateColumn = {
    name: 'expiryDate',
    label: 'Expiry Date',
    options: {
      customHeadRender: () => <HeaderTableCell>Expiry Date</HeaderTableCell>,
      filter: false,
      sortThirdClickReset: true,
      customBodyRenderLite: (dataIndex) => {
        if (entitlements[dataIndex].expiryDate) {
          return formatDate(entitlements[dataIndex].expiryDate)
        }
      },
    },
  }

  const assignStatusColumn = {
    name: 'assignStatus',
    label: 'Status',
    options: {
      customHeadRender: () => <HeaderTableCell>Status</HeaderTableCell>,
      filter: true,
      sortThirdClickReset: true,
    },
  }

  const RegenerateTokenColumn = {
    name: '',
    label: '',
    options: {
      setCellProps: () => ({
        align: 'right',
      }),
      filter: false,
      sort: false,
      customBodyRenderLite: (dataIndex) => {
        const entitlement = entitlements[dataIndex]

        return (
          <AITokenActionButton
            action="regenerate"
            payload={entitlement}
            title="Regenerate Token"
            dispatchResponse={dispatchResponse}
          />
        )
      },
    },
  }

  // Columns displayed for each entitlement type
  let columns = [
    productNameColumn,
    entitlementIdColumn(entitlements),
    startDateColumn,
    expiryDateColumn,
    assignStatusColumn,
    assignedCreatedUser,
  ]

  if (shallDisplayActionButton) {
    columns = [
      productNameColumn,
      entitlementIdColumn(entitlements),
      startDateColumn,
      expiryDateColumn,
      assignStatusColumn,
      assignedCreatedUser,
      RegenerateTokenColumn,
    ]
  }

  const options = {
    filter: false,
    viewColumns: false,
    print: false,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    rowsPerPage: 10,
    elevation: 0,
    rowsPerPageOptions: [5, 10, 15],
    textLabels: {
      body: {
        noMatch: isEntitlementLoading ? (
          <Loader type="ThreeDots" color="grey" />
        ) : (
          'Sorry, there is no matching data to display'
        ),
      },
    },
  }

  return (
    <MUIDataTable
      title={title || 'Entitlements'}
      data={entitlements}
      columns={columns}
      options={options}
    />
  )
}
